import styled from 'styled-components';

export const AppCardContainerStyled = styled(`div`)`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 16px;
	width: 100%;
	height: 180px;
	border: 1px solid #d9d9d9;
	border-radius: 2px;
	cursor: pointer;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		height: 285px;
	}
	@media (min-width: ${props => props.theme.breakpoints.md}) {
		height: 212px;
	}
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		height: 285px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		height: 212px;
		padding: 24px;
	}
`;

export const AppCardTopStyled = styled(`div`)`
	gap: 16px;
	display: flex;
	align-items: center;
	margin-bottom: 10px;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		flex-direction: column;
		align-items: flex-start;
	}
	@media (min-width: ${props => props.theme.breakpoints.md}) {
		flex-direction: row;
	}
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		flex-direction: column;
		align-items: flex-start;
	}
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		flex-direction: row;
	}
`;

export const AppCardLogoStyled = styled(`img`)`
	width: 40px;
	height: 40px;
	border: 1px solid #d9d9d9;
	border-radius: 4px;
`;

export const AppCardNameStyled = styled(`h4`)`
	margin: 0;
	max-width: 212px;
	font-weight: 600;
	font-size: 20px;
	line-height: 28px;
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		max-width: 250px;
	}
`;

export const AppCardDescriptionStyled = styled(`p`)`
	margin: 0;
	color: #000;
	font-weight: 400;
	font-size: 14px;
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		font-size: 16px;
	}
`;

export const AppCardDownloadsStyled = styled(`p`)`
	margin-bottom: 0;
	color: #8c8c8c;
	font-weight: 400;
	font-size: 14px;
`;

export const StatusesContainerStyled = styled.div`
	gap: 8px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		flex-direction: column;
		align-items: flex-start;
	}
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		flex-direction: row;
		align-items: center;
	}
`;

export const ContentContainerStyled = styled.div`
	position: relative;
`;

export const SubscriptionStatusStyled = styled.p`
	margin-bottom: 0;
	font-weight: 400;
	font-size: 12px;
`;

export const DropdownButtonContainerStyled = styled.div`
	position: absolute;
	top: 0;
	right: 0;
`;
